import { Injectable } from '@angular/core';
import {BaseService} from '../base.service';
import {environment} from '../../../../environments/environment';
import {HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Region} from '../../store/region/region.interface';

@Injectable({
  providedIn: 'root',
})
export class RegionService  extends  BaseService{
  public getRegions():Observable<Region[]>{
    return this.getBaseInfo(`${environment.baseUrl}/service/webapi/v1/region`);
  }
}
